import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PillButton } from '../PillButton';
import { SiblingFigure } from '../characters/SiblingFigure';
import { siblings } from '../../data/siblings';
interface TransitionScreenProps {
  autoplay: boolean;
  onDarken: (dark: boolean) => void;
  onNext: () => void;
}
const lines = ['Same roots.', 'Different personalities.', 'Different strengths.'];
export function TransitionScreen({
  autoplay,
  onDarken,
  onNext
}: TransitionScreenProps) {
  const [step, setStep] = useState(0);
  const dark = step >= 4;
  useEffect(() => {
    onDarken(step >= 4);
  }, [step, onDarken]);
  useEffect(() => {
    if (!autoplay || step >= 4) return;
    const t = window.setTimeout(() => setStep(s => s + 1), step === 0 ? 1100 : 900);
    return () => window.clearTimeout(t);
  }, [autoplay, step]);
  const advance = () => setStep(s => Math.min(s + 1, 4));
  return <div className="flex flex-1 flex-col justify-center py-6" onClick={!autoplay && step < 4 ? advance : undefined} role={!autoplay && step < 4 ? 'button' : undefined} tabIndex={!autoplay && step < 4 ? 0 : undefined} onKeyDown={!autoplay && step < 4 ? e => {
    if (e.key === 'Enter' || e.key === ' ') advance();
  } : undefined} data-id="element-437" data-mp="3vu6ymghksvo6">
      <motion.h2 initial={{
      opacity: 0,
      y: 14
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }} className={['font-heading text-[36px] leading-[1] tracking-[-0.02em] transition-colors duration-700', dark ? 'text-white' : 'text-background'].join(' ')} data-id="element-438" data-mp="33h5mz0qptlmx">
        Families are funny.
      </motion.h2>

      <div className="mt-7 space-y-2.5" data-id="element-439" data-mp="2kmqnla0hrqyk">
        {lines.map((line, i) => <AnimatePresence key={line} data-id="element-440" data-mp="2fop2kjji9hkg" data-mpi={i}>
            {step > i && <motion.p initial={{
          opacity: 0,
          x: -10,
          filter: 'blur(4px)'
        }} animate={{
          opacity: 1,
          x: 0,
          filter: 'blur(0px)'
        }} transition={{
          duration: 0.55,
          ease: [0.22, 1, 0.36, 1]
        }} className={['font-body text-[19px] leading-snug transition-colors duration-700', dark ? 'text-white/70' : 'text-[rgba(1,51,43,0.75)]'].join(' ')} data-id="element-441" data-mp="2boy7i3my4fa4">
                {line}
              </motion.p>}
          </AnimatePresence>)}
      </div>

      {/* the character world fades out as the product world arrives */}
      <motion.div className="mt-9 flex items-end justify-between" animate={{
      opacity: dark ? 0.22 : 1
    }} transition={{
      duration: 0.8
    }} data-id="element-442" data-mp="2ou71rnigbngn">
        {siblings.map((s, i) => <motion.div key={s.id} initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3 + i * 0.12,
        type: 'spring',
        stiffness: 260,
        damping: 20
      }} data-id="element-443" data-mp="33pmyy1ebvzh9" data-mpi={i}>
            <SiblingFigure role={s.id} className="h-[70px] w-[70px]" data-id="element-444" data-mp="3hu3qw8rfpfoy" />
          </motion.div>)}
      </motion.div>

      <div className="mt-8 min-h-[104px]" data-id="element-445" data-mp="3dtbex7r6gwoz">
        <AnimatePresence data-id="element-446" data-mp="3rkovqdxpbggb">
          {step >= 4 && <motion.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.25
        }} data-id="element-447" data-mp="3rk6s2w8plzyd">
              <p className="font-heading text-[22px] leading-tight text-primary" data-id="element-448" data-mp="2ywt2xkb968ot">
                Which brings us to another family...
              </p>
              <div className="mt-5" data-id="element-449" data-mp="38u78govn1d2c">
                <PillButton tone="dark" full onClick={onNext} data-id="element-450" data-mp="38v9xssdbb7g5">
                  Go on then
                </PillButton>
              </div>
            </motion.div>}
        </AnimatePresence>
        {!autoplay && step < 4 && <p className="font-body text-[12px] uppercase tracking-[0.18em] text-[rgba(1,51,43,0.4)]" data-id="element-451" data-mp="o62ndz9fd66g">
            Tap to continue
          </p>}
      </div>
    </div>;
}